module.exports = __webpack_public_path__ + "img/split-03.1dba12e3.jpg";